import ProjectCodeListApp from "BusinessCentral/ListApp";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const businessCentralProjectRoute: RouteObject = {
  path: "businesscentralproject",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ProjectCodeListApp,
  }]
};